export default __webpack_public_path__ + "static/media/cont8.bb41ce0e.jpg";